<div class="flex flex-col h-full max-h-full overflow-y-auto">
  <div class="sticky left-0 flex items-center justify-between w-full">
    <div class="space-y-1">
      <h1 class="text-xl font-semibold">Detail díla</h1>
    </div>
    <div class="flex items-center justify-end space-x-2">
      @if (currentUserItemDetailPermissions?.allowEdit && !hideEditButton) {
        <button
          mat-icon-button
          (click)="edit()"
          matTooltip="Zobrazit okno editace itemu"
        >
          <mat-icon svgIcon="mat:edit"></mat-icon>
        </button>
      }
      <button mat-icon-button (click)="close()">
        <mat-icon svgIcon="mat:close"></mat-icon>
      </button>
    </div>
  </div>

  @if (item.removalType) {
    <div
      class="flex items-center gap-3 px-4 py-3 mt-2 font-semibold text-white bg-red-600 rounded"
    >
      <mat-icon svgIcon="mat:delete"></mat-icon>
      <span>Dílo bylo odebráno ze soupisu</span>
      <span class="mx-1">·</span>
      <span>{{ removalTypeLabels[item.removalType] }}</span>
      @if (item.removedAt) {
        <span class="mx-1">·</span>
        <span>{{ item.removedAt | date: "d. M. yyyy" }}</span>
      }
      @if (item.removalNote) {
        <button
          mat-icon-button
          class="text-white"
          matTooltip="Zobrazit poznámku k odebrání"
          (click)="openRemovalNoteDialog()"
        >
          <mat-icon svgIcon="mat:info"></mat-icon>
        </button>
      }
    </div>
  }
  @if (!loading) {
    <div class="grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2">
      <div class="flex flex-col h-full max-h-full space-y-2">
        <!-- !NO IMAGES: Show warning message -->
        @if (
          !pictureService.getMainPictureFullFilename(item) &&
          images.length === 0
        ) {
          <div
            class="flex items-center justify-center w-full h-full p-2 pt-4 space-x-2 card"
          >
            <mat-icon svgIcon="mat:warning" class="text-red-500"></mat-icon>
            <div class="w-1/2 text-center">
              Toto dílo nemá žádnou fotografii
            </div>
            <mat-icon svgIcon="mat:warning" class="text-red-500"></mat-icon>
          </div>
        }
        <!-- !NONE: Only show main page for consistency with item cards list  -->
        @if (
          pictureService.getMainPictureFullFilename(item) &&
          images.length === 0 &&
          (showPhotoMode === "none" || showPhotoMode === "publicOnly")
        ) {
          <div class="card">
            <div class="flex-none w-full h-56 md:h-96">
              <img
                class="object-scale-down w-full h-full p-3"
                [src]="
                  pictureService.getMainPictureFullFilename(item)
                    | photoProxy: '1920:768'
                "
                alt="{{ item.originalTitle }}"
              />
            </div>
            <div
              class="flex items-center justify-center w-full p-2 pt-4 space-x-2"
            >
              <mat-icon
                svgIcon="mat:warning"
                class="text-orange-500"
              ></mat-icon>
              <div class="w-1/2 text-center">
                Toto dílo nemá žádnou veřejnou fotografii.<br />Zobrazuje se
                pouze první neveřejná fotografie.
              </div>
              <mat-icon
                svgIcon="mat:warning"
                class="text-orange-500"
              ></mat-icon>
            </div>
          </div>
        }
        <!-- Show all images that are loaded based on showPhotoMode -->
        @if (images.length > 0 && showPhotoMode !== "none") {
          <div class="w-full h-[23rem] xl:h-[43rem] card">
            <button
              class="relative flex-none w-full h-full"
              (click)="lightbox.openModal(currentImageIndex, images)"
            >
              <img
                class="object-contain w-full h-full p-3"
                [src]="
                  images[currentImageIndex]?.filename +
                    images[currentImageIndex]?.ext | photoProxy: '1920:768'
                "
                alt="{{
                  images[currentImageIndex]?.info
                    ? images[currentImageIndex].info
                    : item.originalTitle
                }}"
              />
              @if (images[currentImageIndex]?.isPublic) {
                <mat-icon
                  class="absolute transition-all duration-300 ease-in-out text-contrast-black bottom-2 right-2 opacity-70 hover:opacity-100 hover:text-green-600"
                  [matTooltip]="'Fotografie je veřejná'"
                  svgIcon="mat:language"
                ></mat-icon>
              }
            </button>
          </div>
        }
        @if (images.length > 0 && showPhotoMode !== "none") {
          <div
            class="flex flex-1 max-w-full space-x-1 overflow-x-auto h-28 card"
          >
            @for (image of images; track image; let i = $index) {
              <button
                class="relative flex-none w-24 h-24"
                (click)="currentImageIndex = i"
              >
                <img
                  class="object-scale-down w-full h-full p-3"
                  [src]="image.filename + image.ext | photoProxy"
                  alt="{{ item.originalTitle }} - {{ i }}"
                />
                @if (image.isPublic) {
                  <mat-icon
                    class="absolute transition-all duration-300 ease-in-out text-contrast-black bottom-2 right-2 opacity-70 hover:opacity-100 hover:text-green-600"
                    [matTooltip]="'Fotografie je veřejná'"
                    svgIcon="mat:language"
                  ></mat-icon>
                }
              </button>
            }
          </div>
        }
      </div>
      <div class="h-full max-h-full">
        <mat-tab-group class="w-full h-[35rem] xl:h-[55rem]" mat-stretch-tabs>
          <mat-tab label="Obecné">
            <!-- Title card -->
            @if (showTitleCard) {
              <div class="mt-2 card md:p-4">
                <h1 class="text-4xl truncate">{{ item.originalTitle }}</h1>
                @if (showAuthor) {
                  <div class="flex">
                    @for (
                      author of item.authors;
                      track author;
                      let last = $last
                    ) {
                      <div>
                        {{ authorService.parseAuthorName(author) }}
                        @if (!last) {
                          <span class="mr-2 -ml-1">{{ "," }}</span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <!-- Other item titles card -->
            @if (showOtherTitlesCard) {
              <div class="mt-2 card md:mt-8 md:p-4">
                <table class="w-full">
                  @if (otherTitles?.length > 0) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Ostatní názvy:</td>
                      <td>
                        <div class="flex flex-col items-start w-full h-full">
                          @for (otherTitle of otherTitles; track otherTitle) {
                            <div>
                              {{ otherTitle.title }}
                              <flag
                                [localeId]="otherTitle.localeId"
                                type="round"
                              ></flag>
                            </div>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </table>
              </div>
            }
            <!-- Inventory card -->
            @if (showInventoryCard) {
              <div class="mt-2 card md:mt-8 md:p-4">
                <table class="w-full">
                  @if (itemType) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Druh díla:</td>
                      <td>{{ itemType }}</td>
                    </tr>
                  }
                  @if (item.inventoryCode) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Inventární číslo:</td>
                      <td>
                        <art-item-inventory-code
                          [item]="item"
                        ></art-item-inventory-code>
                      </td>
                    </tr>
                  }
                  @if (item.parent && item.parentId) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Nadřazené dílo:</td>
                      <td>
                        <div class="flex items-center justify-between w-full">
                          <art-item-inventory-code
                            [item]="item.parent"
                          ></art-item-inventory-code>
                          <div class="flex items-center justify-end">
                            <button
                              class="hover:text-green-500"
                              (click)="goToItemDetail(item.parentId)"
                              mat-icon-button
                              type="button"
                              matTooltip="Přejít na detail díla"
                            >
                              <mat-icon svgIcon="mat:open_in_new"></mat-icon>
                            </button>
                            <button
                              class="hover:text-blue-500"
                              (click)="prepareItemQuickDialog(item.parentId)"
                              mat-icon-button
                              type="button"
                              matTooltip="Zobrazit kartu díla"
                            >
                              <mat-icon svgIcon="mat:info"></mat-icon>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                  @if (item.location) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Umístění:</td>
                      <td>{{ locationString }}</td>
                    </tr>
                  }
                </table>
              </div>
            }
            <!-- Property card -->
            @if (showPropertyCard) {
              <div class="mt-2 card md:mt-8 md:p-4">
                <table class="w-full">
                  @if (dating) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Datace:</td>
                      <td>{{ dating }}</td>
                    </tr>
                  }
                  @if (dimensions) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Rozměry:</td>
                      <td>{{ dimensions }}</td>
                    </tr>
                  }
                  @if (technique) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Technika:</td>
                      <td>{{ technique }}</td>
                    </tr>
                  }
                  @if (substrate) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Podložka:</td>
                      <td>{{ substrate }}</td>
                    </tr>
                  }
                  @if (item.extras?.length > 0) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold">Specifika:</td>
                      <td>
                        @for (e of item.extras; track e; let isLast = $last) {
                          <span>{{ e.title }}</span>
                          @if (!isLast) {
                            <span>, </span>
                          }
                        }
                      </td>
                    </tr>
                  }
                  @if (item.signatures?.length > 0) {
                    <tr class="p-2">
                      <td
                        class="w-1/3 font-semibold"
                        [class.align-top]="item.signatures?.length > 1"
                      >
                        Signatura:
                      </td>
                      <td [class.align-top]="item.signatures?.length > 1">
                        @if (item.signatures?.length > 0) {
                          <div>
                            @for (
                              signature of item.signatures;
                              track signature;
                              let isLast = $last
                            ) {
                              <div>
                                @if (
                                  _signatureService.getSignatureSetup(
                                    signature,
                                    signaturePlaces
                                  );
                                  as signatureSetup
                                ) {
                                  <div
                                    cdkDragHandle
                                    class="flex justify-between w-full py-1"
                                  >
                                    <div
                                      class="flex flex-col items-center justify-center"
                                    >
                                      <div
                                        class="w-full"
                                        [matTooltip]="signatureSetup.title"
                                      >
                                        @if (signatureSetup.label) {
                                          <span
                                            class="mr-1"
                                            [innerHTML]="
                                              sanitizeService.getSafeHtml(
                                                signatureSetup.label,
                                                {
                                                  replaceTags: ['p'],
                                                }
                                              )
                                            "
                                          ></span>
                                        }
                                        @if (
                                          signatureSetup.hasSignaturePlace &&
                                          signatureSetup.title
                                        ) {
                                          <span class="font-semibold"
                                            >{{
                                              "(" + signatureSetup.title + ")"
                                            }}
                                          </span>
                                        }
                                      </div>
                                      @if (signature.commentCS) {
                                        <div class="w-full text-left">
                                          <i
                                            class="w-full text-sm font-extralight"
                                            [innerHTML]="
                                              sanitizeService.getSafeHtml(
                                                signature.commentCS,
                                                {
                                                  replaceTags: ['p'],
                                                }
                                              )
                                            "
                                          >
                                          </i>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                                @if (!isLast) {
                                  <mat-divider></mat-divider>
                                }
                              </div>
                            }
                          </div>
                        }
                      </td>
                    </tr>
                  }
                  @if (item.markings?.length > 0) {
                    <tr class="p-2">
                      <td class="w-1/3 font-semibold align-top">
                        Jiná značení:
                      </td>
                      <td>
                        @if (item.markings?.length > 0) {
                          <div>
                            @for (
                              marking of item.markings;
                              track marking;
                              let isLast = $last
                            ) {
                              <div>
                                @if (
                                  _markingService.getMarkingSetup(
                                    marking,
                                    markingPlaces,
                                    markingTypes
                                  );
                                  as markingSetup
                                ) {
                                  <div class="flex justify-between w-full py-1">
                                    <div
                                      class="flex flex-col items-center justify-center flex-1"
                                    >
                                      <div
                                        class="w-full"
                                        [matTooltip]="markingSetup.title"
                                      >
                                        <div
                                          class="flex items-center justify-start space-x-2"
                                        >
                                          <div class="font-semibold">
                                            {{ markingSetup.label }}
                                          </div>
                                          <mat-icon
                                            class="w-4 h-4"
                                            [svgIcon]="
                                              `mat:${marking.isPublic ? 'public' : 'visibility_off'}`
                                            "
                                            [matTooltip]="
                                              marking.isPublic
                                                ? 'Veřejné značení'
                                                : 'Neveřejné značení'
                                            "
                                          ></mat-icon>
                                        </div>
                                        @if (marking.realText) {
                                          <span
                                            class="mr-1"
                                            [innerHtml]="
                                              sanitizeService.getSafeHtml(
                                                marking.realText,
                                                {
                                                  replaceTags: ['p'],
                                                }
                                              )
                                            "
                                          ></span>
                                        }
                                        @if (
                                          markingSetup.hasMarkingPlace &&
                                          markingSetup.title
                                        ) {
                                          <span class="font-semibold"
                                            >{{
                                              "(" + markingSetup.title + ")"
                                            }}
                                          </span>
                                        }
                                      </div>
                                      @if (marking.commentCS) {
                                        <div class="w-full text-left">
                                          <i
                                            class="w-full text-sm font-extralight"
                                            [innerHTML]="
                                              sanitizeService.getSafeHtml(
                                                marking.commentCS,
                                                {
                                                  replaceTags: ['p'],
                                                }
                                              )
                                            "
                                          ></i>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                                @if (!isLast) {
                                  <mat-divider></mat-divider>
                                }
                              </div>
                            }
                          </div>
                        }
                      </td>
                    </tr>
                  }
                </table>
              </div>
            }
          </mat-tab>
          @if (
            this.item.translations[0].notesPublic &&
            !isEmpty(this.item.translations[0].notesPublic)
          ) {
            <mat-tab label="Popis">
              <div
                class="flex-1 h-full py-2 verflow-y-auto p"
                [innerHTML]="
                  sanitizeService.getSafeHtml(
                    this.item.translations[0].notesPublic,
                    { toHtml: true, replaceTags: ['p'] }
                  )
                "
              ></div>
            </mat-tab>
          }
          @if (item.children?.length > 0) {
            <mat-tab label="Součásti">
              <art-item-preview-children
                [children]="item.children"
                [prepareItemQuickDialog]="prepareItemQuickDialog.bind(this)"
                [goToItemDetail]="goToItemDetail"
              ></art-item-preview-children
            ></mat-tab>
          }
          @if (item.owners?.length > 0) {
            <mat-tab label="Majitelé"
              ><app-item-preview-owners
                [owners]="item.owners"
              ></app-item-preview-owners
            ></mat-tab>
          }
          @if (item.relatedItems?.length > 0) {
            <mat-tab label="Příbuzná díla"
              ><app-item-preview-related-items
                [relatedItems]="item.relatedItems"
              ></app-item-preview-related-items
            ></mat-tab>
          }
          @if (item.auctions?.length > 0) {
            <mat-tab label="Aukce">
              <div class="pt-4">
                <app-item-preview-auctions
                  [auctions]="item.auctions"
                ></app-item-preview-auctions></div
            ></mat-tab>
          }
          @if (item.publications?.length > 0) {
            <mat-tab label="Publikace">
              <div class="pt-4">
                <app-item-preview-publications
                  [publications]="item.publications"
                ></app-item-preview-publications></div
            ></mat-tab>
          }
          @if (item.exhibitions?.length > 0) {
            <mat-tab label="Výstavy">
              <div class="pt-4">
                <app-item-preview-exhibitions
                  [exhibitions]="item.exhibitions"
                ></app-item-preview-exhibitions></div
            ></mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  }
</div>

<custom-lightbox class="z-50"></custom-lightbox>
